import React, { useCallback, useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Plus, SearchIcon, X } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import CommitMentColumn from "Common/Components/CommitMentColumn/CommitMentColumn";
import PaginationTest from "Common/Components/Paginationtest";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import { useDispatch } from "react-redux";
import {
  addCommitmentReducer,
  deleteCommitmentReducer,
  SMSCommitmentFarmerReducer,
} from "slices/Commitment/reducer";
import DeleteModal from "Common/DeleteModal";
import CommitModal from "Common/Components/CommitModal/CommitModal";

const Cutie = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [productListYearCropValue, setproductListYearCropValue] = useState<any>(
    localStorage.getItem("crop_year_id")
  );
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setsize] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();
  const [Datevalues, setDatevaluesValues] = useState<DateObject | null>(
    new DateObject({ calendar: persian }).setLocale(persian_fa)
  );
  const [dataListProvince, setdataListProvince] = useState<any>([]);
  const [ProvinceID, setProvinceID] = useState<any>();
  const [dataListCity, setdataListCity] = useState<any>([]);
  const [CityID, setCityID] = useState<any>();
  const [dataListFarmer, setdataListFarmer] = useState<any>([]);
  const [FarmerID, setFarmerID] = useState<any>();
  const [dataListVillage, setdataListVillage] = useState<any>([]);
  const [dataListVillageID, setdataListVillageID] = useState<any>();
  const [searchvalueSelect, setsearchvalesearchvalueSelect] = useState<any>();
  const [searchVilageSelect, setSearchVilageSelect] = useState<any>();
  const [searchCitySelect, setSearchCitySelect] = useState<any>();
  const [searchProvinceSelect, setSearchProvinceSelect] = useState<any>();
  const [selectedFarmer, setselectedFarmer] = useState<any>();
  const dispatch = useDispatch<any>();
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  const localstorageID = localStorage.getItem("crop_year_id");
  const [isLoadingBtn, setisLoadingBtn] = useState<boolean>();
  const [sortName, setSortName] = useState<any>("");

  const sortLabels: any = {
    // commitment_number: "شماره قرارداد",
    farmer_name: " نام کشاورز",
    amount_of_land: "مقدار زمین(هکتار)",
    withdrawal_amount: "  میزان برداشت (تن)",
  };

  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == localstorageID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const CropYearID = localStorage.getItem("crop_year_id");
        let url =
          "https://api.havirkesht.ir/village/?sort_by=updated_at&sort_order=desc&crop_year_id=${CropYearID}";
        if (searchVilageSelect && searchVilageSelect.trim() != "") {
          url += `&search=${encodeURIComponent(searchVilageSelect.trim())}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataListVillage(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, [searchVilageSelect]);
  console.log(searchVilageSelect);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = `https://api.havirkesht.ir/farmer/?sort_by=updated_at&sort_order=desc`;
        if (searchvalueSelect && searchvalueSelect.trim() !== "") {
          url += `&search=${encodeURIComponent(searchvalueSelect.trim())}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataListFarmer(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    fetchData();
  }, [searchvalueSelect]);
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = `https://api.havirkesht.ir/province/?sort_by=updated_at&sort_order=desc`;
        if (searchProvinceSelect && searchProvinceSelect.trim() !== "") {
          url += `&search=${encodeURIComponent(searchProvinceSelect.trim())}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataListProvince(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, [searchProvinceSelect]);
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = `https://api.havirkesht.ir/city/?sort_by=updated_at&sort_order=desc`;
        if (searchCitySelect && searchCitySelect.trim() !== "") {
          url += `&search=${encodeURIComponent(searchCitySelect.trim())}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataListCity(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, [searchCitySelect]);
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleSelect = (value: number) => {
    setSelectedNumber(value);
    const newSize = value;
    let newPage = currentPage;

    const totalItems = alldata ? Number(alldata) : 0;
    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setsize(newSize);
    setCurrentPage(newPage);

    fetchData(newPage, newSize, sortName);
  };
  useEffect(() => {
    fetchData(currentPage, selectedNumber, sortName);
  }, [currentPage, size, reload, searchValue, sortName]);

  // Get Data
  const fetchData = async (page: any, size: any, sortName: any) => {
    try {
      setData(null);
      const cropYear_ID = localStorage.getItem("crop_year_id");

      let url = `https://api.havirkesht.ir/commitment/?&sort_by=${
        sortName ? sortName : ""
      }&sort_order=desc&crop_year_id=${cropYear_ID}&size=${size}&page=${page}`;
      if (searchValue && searchValue.trim() !== "") {
        url += `&search=${encodeURIComponent(searchValue.trim())}`;
      }

      const res: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });

      const items = res?.data?.items || [];
      setData(items);
      setalldata(res?.data?.total);
      setTotalPages(res?.data?.pages);
      setreload(items.length < 1);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      setErrorMessage(
        error.response
          ? "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
          : "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
      );
      setreload(true);
    }
  };

  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      try {
        const resultAction = await dispatch(deleteCommitmentReducer(eventData));
        if (deleteCommitmentReducer.fulfilled.match(resultAction)) {
          toast.success("عملیات حذف با موفقیت انجام شد");
          setreload(!reload);
        } else {
          toast.error("مشکل در حذف دیتا");
        }
      } catch (error) {
        toast.error("مشکل در حذف دیتا");
      } finally {
        setDeleteModal(false);
        setEventData(null);
      }
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      withdrawal_amount: "",
      amount_of_land: "",
      // commitment_number: "",
    },
    validationSchema: Yup.object({
      withdrawal_amount: Yup.number().required(
        "لطفاً میزان برداشت را وارد کنید"
      ),
      amount_of_land: Yup.number().required("این فیلد الزامی  است"),
      // commitment_number: Yup.number().required(
      //   " لطفا شماره قرارداد را وارد کنید "
      // ),
    }),
    onSubmit: async (values) => {
      setisLoadingBtn(true);
      try {
        if (!dataListVillageID || !FarmerID || !ProvinceID || !CityID) {
          setShow(true);
          return toast.error("لطفا تمامی مقادر را وارد کنید");
        }
        const newData = {
          ...values,
          village_id: Number(dataListVillageID),
          farmer_id: Number(FarmerID),
          crop_year_id: Number(productListYearCropValue),
          // commitment_number: String(values.commitment_number),
          date_set: Datevalues ? Datevalues.format("YYYY/MM/DD") : null,
        };

        dispatch(addCommitmentReducer(newData)).then((result: any) => {
          if (result.payload?.id) {
            const farmerID = Number(result.payload?.id);
            dispatch(SMSCommitmentFarmerReducer(farmerID));
            Swal.fire({
              title: "ثبت قرارداد",
              text: "اطلاعات با موفقیت ثبت شد",
              icon: "success",
            });
            resetFormData();
            validation.resetForm();
            setreload(!reload);

            setisLoadingBtn(false);
          } else {
            Swal.fire({
              title: "ثبت قرارداد",
              text: "ثبت اطلاعات با خطا مواجه شد",
              icon: "error",
            });
          }
        });
      } catch (error: any) {
        console.log(error.message);
        if (error.status === 409) {
          Swal.fire({
            title: "ثبت قرارداد",
            text: "لطفا تمامی موارد رو به درستی وارد کنید ",
            icon: "error",
          });
          setisLoadingBtn(false);
        } else {
          Swal.fire({
            title: "ثبت قرارداد",
            text: "ثبت اطلاعات با خطا مواجه شد",
            icon: "error",
          });
          setisLoadingBtn(false);
        }
      }
      toggle();
    },
  });
  const resetFormData = () => {
    setProvinceID(null);
    setCityID(null);
    setFarmerID(null);
    setselectedFarmer(null);
    setdataListVillageID(null);
    setShow(false);
    setEventData("");
  };

  const toggle = useCallback(() => {
    if (show) {
      resetFormData();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);
  const columnName = (name: any) => {
    setSortName(name);
  };
  const displaySortLabel = sortName ? sortLabels[sortName] || sortName : "";
  const columns = CommitMentColumn({ columnName, onClickDelete });
  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت قرارداد کشاورزان" title=" هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />

      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body ">
          <div className="flex flex-col gap-4 mb-4 sm:flex-row sm:items-center sm:justify-between">
            {/* بخش عنوان و جستجو */}
            <div className="flex  flex-col w-full gap-3 sm:flex-row sm:items-center sm:grow">
              <h6 className="text-15 grow whitespace-nowrap">
                مجموع قراردادها (
                <b className="total-Employs mb-5">{alldata?.toString()}</b>)
                <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                  <span className="whitespace-nowrap p-1">جست‌وجو:</span>
                  <div className="relative w-full sm:w-64">
                    <input
                      type="text"
                      className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                      placeholder="جستجو..."
                      value={searchValue}
                      onChange={(e) => setsearchValue(e.target.value)}
                    />
                    <span className="absolute top-0 inset-y-0 left-2 flex items-center text-gray-400">
                      {searchValue ? (
                        <X
                          size={15}
                          className="cursor-pointer"
                          onClick={() => setsearchValue("")}
                        />
                      ) : (
                        <SearchIcon size={15} />
                      )}
                    </span>
                  </div>
                </label>
              </h6>
              <div className="flex items-center  gap-3">
                <div className="w-full  sm:w-auto">
                  <TableDropDownSmall onSelect={handleSelect} />
                </div>
              </div>
              <div className="shrink-0">
                <Link
                  to="#!"
                  onClick={toggle}
                  type="button"
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
                >
                  <span className="align-middle rtl">ثبت قرارداد جدید</span>{" "}
                  <Plus className="inline-block size-4 rtl" />
                </Link>
              </div>
            </div>
          </div>
          {sortName ? (
            <div className="gap-1 mb-2 items-center flex">
              <X
                size={16}
                className="text-red-600 cursor-pointer"
                onClick={() => setSortName(null)}
              />
              مرتب‌سازی بر اساس: {displaySortLabel}
            </div>
          ) : (
            ""
          )}
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              data={data}
              customnumberfortable={10}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
          {/* صفحه‌بندی */}
          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
      <CommitModal
        show={show}
        toggle={() => setShow(false)}
        validation={validation}
        dataListProvince={dataListProvince}
        dataListCity={dataListCity}
        dataListVillage={dataListVillage}
        dataListFarmer={dataListFarmer}
        ProvinceID={ProvinceID}
        setProvinceID={setProvinceID}
        CityID={CityID}
        setCityID={setCityID}
        dataListVillageID={dataListVillageID}
        setdataListVillageID={setdataListVillageID}
        FarmerID={FarmerID}
        setFarmerID={setFarmerID}
        Datevalues={Datevalues}
        setDatevaluesValues={setDatevaluesValues}
        YearCoptSelect={YearCoptSelect}
        handleClick={handleClick}
        isLoadingBtn={isLoadingBtn}
        searchValueSelect={searchvalueSelect}
        setSearchProvinceSelect={setSearchProvinceSelect}
        setSearchCitySelect={setSearchCitySelect}
        setSearchVilageSelect={setSearchVilageSelect}
        setsearchvalesearchvalueSelect={setsearchvalesearchvalueSelect}
      />
    </React.Fragment>
  );
};

export default Cutie;
